import React, { createContext, useEffect, useState } from "react";
import { useGroupConfig, useOrganizationConfig } from "../hooks";
import { PolicyConfig, PolicyConfigurationScope } from "../types";

type ConfigurationProviderProps = {
  configScope: PolicyConfigurationScope;
  children: React.ReactNode;
};

export const ConfigurationContext = createContext<PolicyConfig | undefined>(
  undefined,
);

export const ConfigurationProvider = ({
  configScope,
  children,
}: ConfigurationProviderProps) => {
  const [hasAnyPolicyConfigLoaded, setHasAnyPolicyConfigLoaded] =
    useState(false);
  const groupPolicyConfig = useGroupConfig({ configScope });
  const organizationPolicyConfig = useOrganizationConfig({ configScope });

  const policyConfig = {
    group: groupPolicyConfig,
    organization: organizationPolicyConfig,
  };

  const selectedPolicyConfig = policyConfig[configScope];

  const isSuccessful = selectedPolicyConfig.status.status === "SUCCESS";

  useEffect(() => {
    if (isSuccessful) {
      setHasAnyPolicyConfigLoaded(true);
    }
  }, [isSuccessful]);

  if (
    selectedPolicyConfig.status.status === "LOADING" &&
    hasAnyPolicyConfigLoaded
  ) {
    // avoid remount on initial switch between org and group policy config
    selectedPolicyConfig.status.status = "FETCHING";
  }

  return (
    <ConfigurationContext.Provider value={selectedPolicyConfig}>
      {children}
    </ConfigurationContext.Provider>
  );
};
